export default __webpack_public_path__ + "images/5b5fe3340997db8bfbffd5fa09b0359f-trustly_bank_1.png";